export enum WorkOrdersQueryKey {
  WorkOrdersByRevisionCode = 'work-orders-by-revision-code',
  WorkOrdersSummary = 'work-orders-summary'
}
